module.exports = __webpack_public_path__ + "img/logo.56fa6028.png";